import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v0/account';

export class AccountService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async fetchAccounts(params: types.FetchAccountsParameters): Promise<types.FetchAccountResponse> {
    const { data } = await this.axios.get<types.FetchAccountResponse>('/accounts', {
      params: params?.query,
    });

    return data;
  }

  async createAccount(params: types.CreateAccountParameters): Promise<types.CreateAccountResponse> {
    const { data } = await this.axios.post<types.CreateAccountResponse>('/accounts', params.body);
    return data;
  }
}
